export class MemoryCardGameServer{
    static evaluateOnServer(exercise: any, correctSolution: any, userSolution: any): Evaluated {
        return { "success": true, "solution": correctSolution, "successPercent": 1 };
    }
}